import content from '../static/index';

const initialState = {
  currentSongIndex: 0,
  barValue: 0,
  isPaused: true,
  audios: content.audios,
  listTypes: content.listTypes,
  typeIndex: 0,
  currentSongIndexChanged: false,
};

const stateReducer = (state, { type, payload }) => {
  switch (type) {
    case 'SET_IS_PAUSED':
      return {
        ...state,
        isPaused: payload.isPaused,
      };

    case 'SET_SONG_TIMELINE':
      const { barValue } = payload;
      return {
        ...state,
        barValue,
      };

    case 'SET_SONG_CURRENT_INDEX':
      const { value } = payload;
      const firstSongIndex = 0;
      const lastSongIndex = state.audios.length - 1;
      const lengthOfListAudios = state.audios.length;
      let nextSongIndex = state.currentSongIndex + value;

      if (nextSongIndex >= lengthOfListAudios) {
        nextSongIndex = firstSongIndex;
      } else if (nextSongIndex < firstSongIndex) {
        nextSongIndex = lastSongIndex;
      }
      return {
        ...state,
        currentSongIndex: nextSongIndex,
        isPaused: false,
        currentSongIndexChanged: true,
      };

    default:
      return state;
  }
};

export { initialState, stateReducer };
